import IconButton from "../../common/IconButton";
import { AddBox as AddBoxIcon } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/CancelRounded";
import { MenuItem, Popover } from "@mui/material";
import Button from "@mui/material/Button";
import { useState } from "react";

const RoleListEditor = ({
  currentRoles,
  addRole,
  removeRole,
  clearRoles,
  allowedRoles,
}) => {
  const [adding, setAdding] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const addableRoles = allowedRoles.filter((r) => !currentRoles.includes(r));
  return (
    <div>
      {addableRoles.length ? (
        <>
          <IconButton
            color={"primary"}
            icon={AddBoxIcon}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setAdding(true);
            }}
          />
          <Popover
            open={adding}
            anchorEl={anchorEl}
            onClick={(e) => {
              const val = e.target.textContent;
              if (addableRoles.includes(val)) {
                addRole(val);
                setAdding(false);
              }
            }}
            onClose={() => {
              setAdding(false);
            }}
          >
            {addableRoles.map((r) => (
              <MenuItem key={"role-list-" + r} value={r}>
                {r}
              </MenuItem>
            ))}
          </Popover>
        </>
      ) : (
        ""
      )}
      {(currentRoles ?? []).map((role) => (
        <Button
          key={"role-button-" + role}
          color={"primary"}
          onClick={() => removeRole(role)}
          endIcon={<ClearIcon fontSize={"smaller"} />}
          disabled={false}
          size={"small"}
          sx={{ margin: "7px 4px 0 0", height: "26px", borderRadius: "13px" }}
          variant={"contained"}
        >
          {role}
        </Button>
      ))}
    </div>
  );
};

export default RoleListEditor;
